import React, { useState, useEffect } from 'react';
import { createAdminPortfolio, updateAdminPortfolio } from '../../composables/fetchAPI';
import toast from 'react-hot-toast';

export default function CreateShayPortfolioModal({ isOpen, onClose, onSuccessfullyCreated, initialData }: any) {
  const [loading, setLoading] = useState(false);
  const isEditMode = !!initialData; // เช็คว่าเป็นโหมดแก้ไขหรือไม่

  const [formData, setFormData] = useState({
    name: "Shay",
    description: "พอร์ตการลงทุนของจารย์เชย์"
  });

  // ถ้าเป็นโหมดแก้ไข ให้โหลดข้อมูลเดิมมาใส่ฟอร์ม
  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setFormData({
          name: initialData.name || "",
          description: initialData.description || ""
        });
      } else {
        // ค่าเริ่มต้นสำหรับสร้างใหม่
        setFormData({
          name: "Shay",
          description: "พอร์ตการลงทุนของจารย์เชย์"
        });
      }
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleSave = async () => {
    try {
      setLoading(true);

      if (isEditMode) {
        // ==========================================
        // ✏️ โหมดแก้ไขพอร์ตเดิม
        // ==========================================
        const portId = initialData.adminPortfolioId || initialData.portfolioId || initialData.id;
        const res = await updateAdminPortfolio(portId, {
          name: formData.name,
          description: formData.description
        });
        
        toast.success("แก้ไขข้อมูลพอร์ตสำเร็จ!");
        onSuccessfullyCreated();
        onClose();
        
      } else {
        // ==========================================
        // ✨ โหมดสร้างพอร์ตใหม่
        // ==========================================
        const timestamp = Date.now();
        const adminPortfolioId = `ADMIN-SHAY-${timestamp}`;
        const slug = `shay-${timestamp}`;

        const res = await createAdminPortfolio({
          adminPortfolioId: adminPortfolioId,
          slug: slug,
          name: formData.name,
          description: formData.description,
          portfolioType: "STOCK",
          baseCurrency: "USD",
          visibilityStatus: "private",
          ownerDisplay: {
            name: "Shay Port",
            title: "Portfolio Manager"
          },
          publicView: {
            showCashBalance: true,
            showAverageCost: true,
            showTotalReturn: true,
            showTransactionHistory: true
          }
        });

        if (res.success || res.code === "OK") {
          toast.success("สร้างพอร์ตจารย์เชย์สำเร็จ!");
          onSuccessfullyCreated();
          onClose();
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(isEditMode ? "เกิดข้อผิดพลาดในการแก้ไขพอร์ต" : "เกิดข้อผิดพลาดในการสร้างพอร์ต");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="bg-[#18181b] border border-yellow-500/30 w-full max-w-md rounded-2xl p-6 text-white shadow-2xl">
        <div className="flex justify-between items-center mb-4 border-b border-gray-700 pb-3">
          <h2 className="text-lg font-bold text-yellow-400">
            {isEditMode ? '✏️ แก้ไขข้อมูลพอร์ต' : '✨ สร้างพอร์ตจารย์เชย์'}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white font-bold">✕</button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-xs text-gray-400">ชื่อพอร์ต</label>
            <input 
              type="text" 
              value={formData.name} 
              onChange={e => setFormData({...formData, name: e.target.value})}
              className="w-full bg-black/40 border border-gray-700 rounded p-2 text-sm mt-1 focus:border-yellow-400 outline-none"
              placeholder="ระบุชื่อพอร์ต..."
            />
          </div>

          <div>
            <label className="text-xs text-gray-400">คำอธิบาย</label>
            <textarea 
              value={formData.description} 
              onChange={e => setFormData({...formData, description: e.target.value})}
              className="w-full bg-black/40 border border-gray-700 rounded p-2 text-sm mt-1 focus:border-yellow-400 outline-none resize-none h-24"
              placeholder="ระบุคำอธิบายพอร์ต..."
            />
          </div>

          <div className="flex justify-end gap-2 pt-4 border-t border-gray-800">
            <button 
              onClick={onClose}
              className="bg-gray-700 hover:bg-gray-600 text-white font-bold px-4 py-2 rounded text-sm transition-colors"
            >
              ยกเลิก
            </button>
            <button 
              onClick={handleSave}
              disabled={loading}
              className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold px-5 py-2 rounded text-sm transition-colors disabled:opacity-50"
            >
              {loading ? 'กำลังบันทึก...' : (isEditMode ? '💾 บันทึกการแก้ไข' : '🚀 ยืนยันสร้างพอร์ต')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}